import React from 'react';

/**
 * @typedef {object} GoogleFontsIconOwnProps
 * @property {string} [dataTestId]
 * @property {*} [iconType]
 */

/**
 * @typedef {GoogleFontsIconOwnProps & React.ComponentProps<'span'>} GoogleFontsIconProps
 */

/**
 * @param {GoogleFontsIconProps} props
 */
const GoogleFontsIcon = props => {
  const { iconType, dataTestId, ...otherProps } = props;

  return (
    <span {...otherProps} data-testid={dataTestId}>
      {iconType}
    </span>
  );
};

export default GoogleFontsIcon;
